import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { LoanService } from "../shared/loan.service";
import { PrintloanrequestformService } from "../../loan/shared/print/printloanrequestform.service";
import { RptloanpopupComponent } from "../shared/popup/rptloanpopup/rptloanpopup.component";
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-loanlist',
  templateUrl: './loanlist.component.html',
  styleUrls: ['./loanlist.component.css']
})
export class LoanlistComponent implements OnInit {

  displayedColumns: string[] = ['Application No', 'Application Date', 'Customer', 'Status', 'Scheme', 'Center', 'Amount', 'New'];

  LoanApprovedStatus: Number = 0;

  dataSource = new MatTableDataSource<any>();
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  constructor(private router: Router, private loanService: LoanService,
    public dialog: MatDialog, private printloanrequestformService: PrintloanrequestformService,
  ) { }

  ngOnInit() {
    this.getLoanList();
    this.dataSource.paginator = this.paginator;
  }

  applyFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // MatTableDataSource defaults to lowercase matches
    this.dataSource.filter = filterValue;
  }

  getLoanList() {

    this.loanService.FetchLoanList(this.LoanApprovedStatus)
      .toPromise()
      .then(data => {
        this.dataSource.data = data;
      })
      .catch(err => { console.log(err) });
  }

  public AddNewLoan() {
    this.router.navigate(['/loan']);
  }

  EditLoan(loan: any) {
    this.router.navigate(['/loan', loan.Id]);
  }

  PrintLoan(loan: any) {
    let val = null;
    val = {
      Id: loan.Id,
      CustomerId: loan.CustomerId,
      ReportName: "LoanRequestForm",
      FromDate: JSON.parse(localStorage.getItem("EmployeeData"))["ApplicationDate"], //new Date(),
      ToDate: JSON.parse(localStorage.getItem("EmployeeData"))["ApplicationDate"],  //new Date(),
    };
    this.printloanrequestformService.GenerateReport(val);
  }

  animal: string;
  name: string;

  openDialog(): void {
    const dialogRef = this.dialog.open(RptloanpopupComponent, {
      width: '300px', height: '400px',
      data: { name: this.name, animal: this.animal }
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
      // this.animal = result;

    });
  }
}
